import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  PlusCircle,
  RotateCcw,
  ChevronUp,
} from "feather-icons-react/build/IconComponents";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getDiscountList } from "../../services/MasterApiServices";
import { useEffect } from "react";
import DiscountModal from "../../components/master/modal/DiscountModal";
import { getDiscountbyguid } from "../../services/MasterApiServices";
import { deleteDiscount } from "../../services/MasterApiServices";
import { OverlayTrigger } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { setheadertoggle } from "../../redux/toggle";
import {
  exportExcel,
  exportPDF,
  HandlePrint,
  renderTooltip,
} from "../../redux/helper";
import { exportMasterExcel, exportMasterPDF, printMasterReport } from "../../core/utils/MasterReportUtils";
import { MasterName } from "../../components/master/ui/masterUi";
import MasterScreen from "../../components/master/ui/MasterScreen";

const Discount = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [discountData, setDiscountData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [updateData, setUpdateData] = useState([]);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const {menuItems} = useSelector((state) => state.amc);
  const [permit, setpermit] = useState();
  // Get user from redux
  const { userId } = useSelector((state) => state.userauth);

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  // Fetch the discount list when the component mounts
  useEffect(() => {
    setpermit(menuItems?.menuPermissions?.find(e=> e.menu.name =="Discount"))
    handleDiscountList();
  }, []);

  // Fetch the discount lists
  const handleDiscountList = async () => {
    try {
      const response = await getDiscountList();

      if (Array.isArray(response)) {
        setDiscountData(response);
      } else {
        setDiscountData([]);
      }
    } catch (error) {
      console.log(error?.response?.data?.Message || "something went wrong");
      setDiscountData([]);
    }
  };

  //handle the search
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const modifiedList = Array.isArray(discountData)
    ? discountData?.filter((value) =>
        value.name?.toLowerCase().includes(searchText?.toLowerCase())
      )
    : [];

  // Handle the click event to edit a discount
  const handleEditClick = async (guid) => {
    try {
      const response = await getDiscountbyguid(guid);
      setUpdateData(response.data ? response.data : []); // Set the data for editing
      setModalMode("edit"); // Set the modal mode to 'edit'
      setModalOpen(true); // Open the modal
    } catch (error) {
      console.error(
        "Error fetching discount by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  // Initialize SweetAlert with ReactContent
  const MySwal = withReactContent(Swal);

  // Handle the click event to delete a discount
  const handleDeleteClick = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      console.log(result);
      if (result.isConfirmed) {
        try {
          const response = await deleteDiscount(id);
          if (response?.data === true) {
            MySwal.fire({
              title: "Deleted!",
              text: "The discount has been deleted.",
              icon: "success",
              confirmButtonColor: "#00ff00",
              confirmButtonText: "OK",
            }).then(() => {
              handleDiscountList(); // Refresh the list
              setSearchText(""); // Clear the search text
            });
          } else {
            MySwal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonColor: "#ff0000",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error(
            "Error deleting discount:",
            error?.response?.data?.Message || "something went wrong"
          );
          MySwal.fire({
            title: "Error!",
            text: error?.response?.data?.Message || "something went wrong",
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <MasterName text={text} />,
      sorter: (a, b) => a.name?.length - b.name?.length,
    },
    {
      title: "Percentage",
      dataIndex: "percentage",
      sorter: (a, b) => a.percentage?.length - b.percentage?.length,
    },
    ...(permit?.edit || permit?.deletion
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_, obj) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  {permit?.edit && (
                    <Link
                      className="me-2 p-2"
                      to="#"
                      onClick={() => handleEditClick(obj.guid)}
                    >
                      <i data-feather="edit" className="feather-edit"></i>
                    </Link>
                  )}
                  {permit?.deletion && (
                    <Link
                      className="confirm-text p-2"
                      to="#"
                      onClick={() => handleDeleteClick(obj.id)}
                    >
                      <i data-feather="trash-2" className="feather-trash-2"></i>
                    </Link>
                  )}
                </div>
              </div>
            ),
          },
        ]
      : [])
  ];
  // Filter the discounts based on the search text
  const filteredData = discountData
    ?.filter((entry) => {
      return Object.keys(entry).some((key) => {
        return String(entry[key])
          .toLowerCase()
          .includes(searchText.toLowerCase());
      });
    })
    .sort((a, b) => b.createdAt - a.createdAt); // Ensure new items appear on top
    const getActiveTabData = () => {
      let fieldMapping = {};
    
      // Function to create the field mapping between column titles and dataIndex values
      const createfieldMapping = (columns) => {
        const mappings = {};
        columns.forEach((col) => {
          mappings[col.title] = col.dataIndex; // Map title to dataIndex
        });
        return mappings;
      };
    
      // Generate the field mapping for the current columns
      fieldMapping = createfieldMapping(columns);
      
      // Return the filtered data, columns, and field mapping
      return { data: modifiedList, columns: columns, fieldMapping, Rname: "Discount"};
    };
  return (
    <MasterScreen
      title="Discount"
      subtitle="Manage discounts here"
      count={modifiedList?.length}
      tools={
        <ul className="table-top-head">
                      <li>
                        <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                          <Link
                            onClick={() => exportMasterPDF(getActiveTabData,"Discount")}
                          >
                            <ImageWithBasePath
                              src="assets/img/icons/pdf.svg"
                              alt="img"
                            />
                          </Link>
                        </OverlayTrigger>
                      </li>
                      <li>
                        <OverlayTrigger
                          placement="top"
                          overlay={renderTooltip("Excel")}
                        >
                          <Link
                            onClick={() => exportMasterExcel(getActiveTabData,"Discount")}
                          >
                            <ImageWithBasePath
                              src="assets/img/icons/excel.svg"
                              alt="img"
                            />
                          </Link>
                        </OverlayTrigger>
                      </li>
                      <li>
                        <OverlayTrigger
                          placement="top"
                          overlay={renderTooltip("Print")}
                        >
                          <Link
                            onClick={() => printMasterReport(getActiveTabData,"Discount")}
                          >
                            <i data-feather="printer" className="feather-printer" />
                          </Link>
                        </OverlayTrigger>
                      </li>
                      <li>
                        <OverlayTrigger
                          placement="top"
                          overlay={renderTooltip("Refresh")}
                        >
                          <Link
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            onClick={() => handleDiscountList()}
                          >
                            <RotateCcw />
                          </Link>
                        </OverlayTrigger>
                      </li>
                      <li>
                        <OverlayTrigger
                          placement="top"
                          overlay={renderTooltip("Collapse")}
                        >
                          <Link
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            id="collapse-header"
                            className={togglehead ? "active" : ""}
                            onClick={handletogglehead}
                          >
                            <ChevronUp />
                          </Link>
                        </OverlayTrigger>
                      </li>
                    </ul>
      }
      onNew={permit?.add ? () => {
                  setModalMode("add"); // Set the modal mode to 'add'
                  setModalOpen(true); // Open the modal
                } : undefined}
      searchValue={searchText}
      onSearchChange={handleSearch}
      onSearchClear={() => setSearchText("")}
      searchPlaceholder="Search discount - any part"
      columns={columns}
      dataSource={modifiedList}
      onRowClick={permit?.edit ? (r) => handleEditClick(r.guid) : undefined}
      selectedKey={modalOpen && modalMode === "edit" ? (updateData?.id ?? updateData?.guid) : null}
      detail={
        modalOpen ? (
          <DiscountModal
                  mode={modalMode}
                  data={modalMode === "edit" ? updateData : {}}
                  handleClose={() => setModalOpen(false)}
                  handleRefresh={() => {
                    handleDiscountList(); // Refresh the list
                    setSearchText(""); // Clear the search text
                  }}
                />
        ) : null
      }
    />
  );
};

export default Discount;
